import { Box, Stack } from "@mui/material";
import useIsSmallScreen from "../../../hooks/useIsSmallScreen";


const FooterContainer = (props) => {

    const isSmallScreen = useIsSmallScreen();

    return (
        <Box sx={{
            height: "250px",
            width: "100%",
            background: "black",
            position: "relative",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-around",
            alignItems: "center" }}
            mt={5}>

            <Stack direction="column">

                {props.children}
            </Stack>

            {!isSmallScreen && <img src="/static/images/Logo.png" alt="" style={{ height: "inherit" }}/> }

        </Box>
    );
}

export default FooterContainer;